import { Anchor, Button, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { useEffect, useState } from 'react';
import {
  denyAnalyticsConsent,
  getAnalyticsConsentState,
  grantAnalyticsConsent,
  initializeAnalyticsConsent,
  subscribeToAnalyticsConsent,
  type AnalyticsConsentState,
} from '../../services/analyticsService';

const PUBLIC_SITE_URL = import.meta.env.VITE_PUBLIC_SITE_URL || 'https://thegameproject.net';

export default function AnalyticsConsent() {
  const [state, setState] = useState<AnalyticsConsentState>(getAnalyticsConsentState());

  useEffect(() => {
    const unsubscribe = subscribeToAnalyticsConsent(setState);
    initializeAnalyticsConsent().catch(() => setState('prompt'));
    return unsubscribe;
  }, []);

  if (state !== 'prompt') return null;

  return (
    <Paper
      role="dialog"
      aria-labelledby="analytics-consent-title"
      aria-describedby="analytics-consent-description"
      shadow="xl"
      withBorder
      p="lg"
      pos="fixed"
      bottom={20}
      left={20}
      right={20}
      style={{ zIndex: 1000, maxWidth: 1120, marginInline: 'auto' }}
    >
      <Group justify="space-between" align="center" gap="lg">
        <Stack gap={4} style={{ flex: 1 }}>
          <Title order={2} size="h4" id="analytics-consent-title">
            Help us improve
          </Title>
          <Text size="sm" id="analytics-consent-description">
            Analytics helps us understand how people find and use The Game Project.{' '}
            <Anchor href={`${PUBLIC_SITE_URL}/privacy`} target="_blank" rel="noopener noreferrer">
              Privacy details
            </Anchor>
          </Text>
        </Stack>
        <Group gap="sm">
          <Button variant="subtle" color="gray" onClick={denyAnalyticsConsent}>
            Decline
          </Button>
          <Button onClick={grantAnalyticsConsent}>Allow</Button>
        </Group>
      </Group>
    </Paper>
  );
}
